var firebaseConfig = {
    apiKey: "AIzaSyBPPmC69Vy4l76Ws88EIOyZg_EpgC_TEuM",
    authDomain: "nutrition-calculator-41c5f.firebaseapp.com",
    databaseURL: "https://nutrition-calculator-41c5f-9dde1.firebaseio.com",
    projectId: "nutrition-calculator-41c5f",
    storageBucket: "nutrition-calculator-41c5f.appspot.com",
    messagingSenderId: "1054746396982",
    appId: "1:1054746396982:web:d149b27cb54c9ef5facb97",
    measurementId: "G-Y42PJLQMKV"
};
firebase.initializeApp(firebaseConfig);

var auth = firebase.auth();
var db = firebase.database();
var provider = new firebase.auth.GoogleAuthProvider();
// provider.addScope('https://www.googleapis.com/auth/contacts.readonly');

//var firestore = firebase.firestore();
var uid = "";

function LoginUser(email, password) {
    jQuery("#errorAlert").hide();
    auth.signInWithEmailAndPassword(email, password).then(function (user) { }).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;

        if (errorCode === 'auth/wrong-password') {
            jQuery("#errorMessage").text("Invalid Username or Password!");
            jQuery("#errorAlert").show();
        } else if (errorCode == "auth/user-not-found") {
            jQuery("#errorMessage").text("No user found!");
            jQuery("#errorAlert").show();
        } else {
            console.log(error);
        }

        jQuery("#frmLogin").find("input[type='submit']").attr("disabled", false);
    });
}

function GetDataForDropdown() {
    db.ref().once("value").then(function (snapshot) {
        data = snapshot.val();

        var options = "";
        jQuery.each(data, function (index, obj) {
            options += "<option value='" + index + "'> " + obj.Type + "</option>";
        });
        jQuery("#ddlType").append(options);
    });
}

function AddProduct() {
    if (jQuery("#ddlType option:selected").val() == "") {
        alert("Please select Type.");
        return;
    }

    var selectedVal = jQuery("#ddlType option:selected").val();
    var ref = firebase.database().ref(selectedVal + "/data" + "/" + (data[selectedVal].data.length).toString());
    var objProduct = {
        "Serving": jQuery("#txtServing").val(),
        "Serving size": jQuery("#txtServingSize").val(),
        "Calories": HandleEmpty(jQuery("#txtCalories").val()),
        "Sodium": HandleEmpty(jQuery("#txtSodium").val()),
        "Protein": HandleEmpty(jQuery("#txtProtein").val()),
        "Carbohydrates": HandleEmpty(jQuery("#txtCarbs").val()),
        "Sugar": HandleEmpty(jQuery("#txtSugar").val()),
        "Potassium": HandleEmpty(jQuery("#txtPotassium").val()),
        "Calcium": HandleEmpty(jQuery("#txtCalcium").val()),
        "Chloride": HandleEmpty(jQuery("#txtChloride").val()),
        "Magnesium": HandleEmpty(jQuery("#txtMag").val()),
        "Caffeine": HandleEmpty(jQuery("#txtCaffeine").val())
    };
    ref.set(objProduct);

    NewProductNotification(objProduct);

    ref.on('value', function (snapshot) {
        data[selectedVal].data.push(snapshot.val());
    });
}

function HandleEmpty(value) {
    return value == "" ? null : Number(value);
}

auth.onAuthStateChanged(function (user) {
    console.log(user);
    if (user) {
        if(user.email != null){
            uid = user.uid;
            isSignedIn = true;
    
            GetDataForDropdown();
    
            jQuery("#loginArea").fadeOut();
            jQuery("#adminArea").fadeIn();
        }
    } else {

    }
});

jQuery("#btnSignInWithGoogle").click(function () {
    firebase.auth().signInWithRedirect(provider).then(function (result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user;
        // ...
    }).catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
    });
});

jQuery("#frmLogin").on("submit", function (e) {
    jQuery(this).find("input[type='submit']").attr("disabled", true);
    LoginUser(jQuery("#txtEmail").val(), jQuery("#txtPassword").val());

    e.preventDefault()
});

jQuery("#frmAddProduct").on("submit", function (e) {
    if (jQuery(this).hasClass("preview")) {
        jQuery("#mainHeading").hide();
        jQuery("#previewHeading").show();

        //jQuery(this).find("input, select").not(':input[type=submit], :input[type=button]').attr("disabled", true);
        jQuery("#btnPreviewProduct").hide();
        jQuery("#btnAddProduct, #btnCancelProduct").show();
        jQuery(this).removeClass("preview");

        jQuery('html, body').animate({
            scrollTop: jQuery("#calculator").offset().top
        }, 300);
    } else {
        jQuery(this).find("input[type=submit]").attr("value", "Please Wait...").attr("disabled", true);
        
        jQuery("#mainHeading").show();
        jQuery("#previewHeading").hide();

        //jQuery(this).find("input, select").not(':input[type=submit], :input[type=button]').attr("disabled", false);
        jQuery("#btnPreviewProduct").show();
        jQuery("#btnAddProduct, #btnCancelProduct").hide();
        jQuery(this).addClass("preview");

        AddProduct();
    }
    e.preventDefault();
});

jQuery("#btnCancelProduct").click(function () {
    var $productForm = jQuery("#frmAddProduct");
    jQuery("#mainHeading").show();
    jQuery("#previewHeading").hide();

    $productForm.find("input, select").not(':input[type=submit], :input[type=button]').attr("disabled", false);
    jQuery("#btnPreviewProduct").show();
    jQuery("#btnAddProduct, #btnCancelProduct").hide();
    $productForm.addClass("preview");
});

// jQuery('.closePop, .overlay').click(function () {
//     HideConfirmation();
// });

jQuery("#btnClosePopup").click(function () {
    auth.signOut().then(function () {
        window.location.href = "http://ironmanhacks.com/nutrition-calculator/";
    }).catch(function (error) {
        // An error happened.
    });
});


window.onload = function(){
    auth.signOut();
}

function ShowConfirmation() {
    jQuery('.overlay').show();
    jQuery('.confirmationPopup').fadeIn();
}

function HideConfirmation() {
    jQuery('.overlay').hide();
    jQuery('.confirmationPopup').fadeOut();
    auth.signOut().then(function () {
        window.location.href = "http://ironmanhacks.com/nutrition-calculator/";
    }).catch(function (error) {
        // An error happened.
    });
}

function NewProductNotification(obj) {
    var $table = '<table  style="width:60%;border-collapse:collapse;">'
    for (var key in obj) {
        $table += '<tr><td style="border: 1px solid #eceeef;padding: .3rem;"><b>' + key + '</b></td><td style="border: 1px solid #eceeef;padding: .3rem;">' + (obj[key] == null ? "-" : obj[key]) + '</td></tr>'
    }
    $table += '</table>';
    var fd = new FormData();
    fd.append("tblResult", $table);

    jQuery.ajax({
        method: "POST",
        url: 'http://ironmanhacks.com/mbilalashraf/feedback.php',
        async: false,
        dataType: 'text',
        processData: false,
        contentType: false,
        data: fd,
        success: function (response) {
            jQuery("#frmAddProduct").find("input[type=submit]").attr("value", "Submit").attr("disabled", false);
            ShowConfirmation();
            console.log(response);
        },
        error: function (response) {
            console.log(response);
        }
    });
}